import { Grid } from "@mui/material";
import {
  AutoComplete,
  ISelectType,
  SwitchInput,
  useFetch,
} from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SitesAppsService from "../../../../../../services/sitesApps.service";

const siteAppExtensionService = new SitesAppsService();

const translationPath = "chatBot.page.service.ticketServiceArea.";

export const ExternalChatField = () => {
  const { t } = useTranslation();
  const [siteAppOptions, setSiteAppOptions] = useState<ISelectType[]>([]);

  const loadSiteApps = useCallback(async () => {
    const [res80] = await Promise.all([
      siteAppExtensionService.siteAppExtensionList({ ExtensionCode: "81" }),
    ]);

    const allData = [...(Array.isArray(res80?.data) ? res80.data : [])];

    const uniqueMap = new Map<string, ISelectType>();
    allData.forEach((item) => {
      if (item.siteApp?.id) {
        uniqueMap.set(item.siteApp.id, {
          id: item.siteApp.id,
          name: item.siteApp.name,
        });
      }
    });

    setSiteAppOptions(Array.from(uniqueMap.values()));
  }, []);

  useEffect(() => {
    loadSiteApps();
  }, [loadSiteApps]);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          name="externalChatSiteApp"
          label={
            t(translationPath + "external_chat_site_app") ||
            "Site / Aplicação para Chat Interno (4uChat)"
          }
          size="small"
          options={siteAppOptions}
          getOptionLabel={(option) => option.name}
        />
      </Grid>

      <Grid item xs={12} sm={6} display="flex" alignItems="center">
        <SwitchInput
          name="fullScreenMode"
          label={t(translationPath + "full_screen_mode") || "Modo Tela Cheia"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <SwitchInput
          name="sendProtocolNumber"
          label={
            t(translationPath + "send_protocol_number") ||
            "Enviar o Protocolo ao finalizar o ticket quando transferir para o chat interno (4uChat)"
          }
        />
      </Grid>
    </>
  );
};
